jQuery.noConflict();     
jQuery(document).ready(function($){
	$(function(){
		$('#slider').anythingSlider({
			vertical: true,
			buildArrows: false,
			buildStartStop: false,
			hashTags: false,
			autoPlay: true,
			autoPlayLocked: false,
			navigationFormatter: function(index, slide) {
				var template = "<span class='title'>{0}</span><p>{1}</p><span class='navArrow'>&nbsp;</span>",
					title = $(slide).find("img").data("nav-title"),
					description = $(slide).find("img").data("nav-description");
					return template.replace("{0}",title).replace("{1}",description);
			}
		});
	});
});